// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__GGlf4","content":"styles_content__3Vo62","selectAll":"styles_selectAll__1D5yl"};